import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import store from './store/store';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { trackInit } from './utils/tracker';
import { configuration } from './configuration';

trackInit({
  mixId: configuration.app.mixpanel[configuration.mode],
});

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

//unregister for make sure Service Worker will not run
unregister();
//registerServiceWorker();
